module.exports = __webpack_public_path__ + "static/media/Houndour_gaussian2.58fcb4d3.png";